'use es6';

import { useState, useEffect, useMemo, useCallback, useRef, forwardRef } from 'react';
import { throttle } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
const THROTTLE_TIME = 200;
const PIXEL_OFFSET = 100;
export default function withVisibilityChecker() {
  return Component => {
    const WithVisibilityChecker = /*#__PURE__*/forwardRef((props, ref) => {
      const [isVisible, setIsVisible] = useState(false);
      const nodeRef = useRef(null);
      const updateVisibility = useCallback(() => {
        if (!nodeRef.current) return;
        const {
          top
        } = nodeRef.current.getBoundingClientRect();
        const isCurrentlyVisible = top < window.innerHeight + PIXEL_OFFSET && top > -PIXEL_OFFSET;
        if (isVisible !== isCurrentlyVisible) {
          setIsVisible(isCurrentlyVisible);
        }
      }, [isVisible]);
      const handleScroll = useMemo(() => throttle(() => {
        updateVisibility();
      }, THROTTLE_TIME), [updateVisibility]);
      useEffect(() => {
        const timeout = setTimeout(() => {
          updateVisibility();
        }, 0);

        /* Have to do both wheel and scroll, module forms do not scroll document, but settings does */
        document.addEventListener('scroll', handleScroll);
        document.addEventListener('wheel', handleScroll);
        return () => {
          if (timeout) {
            clearTimeout(timeout);
          }
          document.removeEventListener('scroll', handleScroll);
          document.removeEventListener('wheel', handleScroll);
        };
      }, [handleScroll, updateVisibility]);
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        ref: ref || nodeRef,
        isVisible: true
      }));
    });
    WithVisibilityChecker.displayName = `WithVisibilityChecker(${Component.displayName || Component.name || 'Component'})`;
    return WithVisibilityChecker;
  };
}